import { WifiOff } from 'lucide-react';
import { Text } from '../design-system/Text';

export function OfflineState() {
  return (
    <div className="mx-4 mt-3 flex items-center gap-2 rounded-lg bg-red-50 p-3 text-red-800 dark:bg-red-900/20 dark:text-red-200">
      <WifiOff className="h-5 w-5 shrink-0" />
      <Text variant="body-medium" className="text-red-900 dark:text-red-100">
        You're offline. Selections are disabled until connection returns.
      </Text>
    </div>
  );
}
